import React, { useEffect, useState } from 'react'
import DfbHeadline from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline'
import DfbImage from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_image'
import Section from '@dfb/gatsby-dfb-theme/src/components/blocks/section'
import { conditionalLinkTarget } from '@dfb/gatsby-dfb-theme/src/components/utilities'
import { CareerFact, Image } from '../../types/types'

const MCareerFacts = ({ data }) => {
  const {
    headline,
    image,
    career_facts,
  }: {
    headline: string
    image: Array<Image>
    career_facts: Array<CareerFact>
  } = data

  const [personioCount, setPersonioCount] = useState(null)

  useEffect(() => {
    if (career_facts.some((fact) => fact.career_facts_personio_jobs === 1)) {
      const fetchPersonioCount = async () => {
        try {
          const res = await fetch(process.env.PERSONIO_API_URL)
          if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`)
          }
          const { data, success } = await res.json()
          if (!success) {
            throw new Error(`Response error! data: ${data}`)
          }
          setPersonioCount(data.jobCount)
        } catch (error) {
          console.warn('Error while loading personio count:', error)
        }
      }

      fetchPersonioCount()
    }
  }, [career_facts])

  return (
    <Section
      baseClass="m-CareerFacts"
      className={data.layout === 'umbrella-branding' ? 'm-CareerFacts--dachmarke' : ''}
      data={data}
      defaultPadding="large"
    >
      <div className="m-CareerFacts-wrapper">
        <div className="m-CareerFacts-container">
          <div className="m-CareerFacts-content">
            {headline && <DfbHeadline headline={headline} headline_level="h2" add_class="m-CareerFacts-headline" />}

            <div className="m-CareerFacts-cards">
              <div className="m-CareerFacts-image-wrapper">
                {image && image.length > 0 && <DfbImage image={image[0]} add_class="m-CareerFacts-image u-Image--xs u-Image-cover" />}
              </div>

              {career_facts?.map((fact) => (
                <a
                  href={fact.career_facts_link}
                  className="c-CardFact c-CardFact-card dfb-Card"
                  {...conditionalLinkTarget(fact.career_facts_link, fact.career_facts_link_obj)}
                >
                  <div className="c-CardFact-content dfb-Card-content">
                    <h4 className="dfb-Headline dfb-Headline--h1 c-CardFact-headline">
                      {fact.career_facts_personio_jobs === 1 && personioCount ? personioCount : fact.career_facts_number}
                    </h4>
                    <h5 className="dfb-Headline dfb-Headline--h5 c-CardFact-subline">{fact.career_facts_headline}</h5>
                    <p className="dfb-Paragraph c-CardFact-description">{fact.career_facts_text}</p>
                    <div className="dfb-Anchor dfb-Anchor--secondary c-CardFact-anchor">
                      <span className="dfb-Anchor-label">{fact.career_facts_link_text}</span>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MCareerFacts
